module.exports = __webpack_public_path__ + "static/media/maibine.a10d96a2.png";